var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MessageType } from '../shared/model/message-type';
import { SocketService } from '../shared/services/socket.service';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { GameComponent } from '../game/game.component';
import { GameStatus } from '../shared/model/game-status';
import { SECOND } from '../shared/consts/conts';
import { TimerComponent } from '../timer/timer.component';
var TriviaComponent = /** @class */ (function (_super) {
    __extends(TriviaComponent, _super);
    function TriviaComponent(socketService, cookieService, router, resolver) {
        var _this = _super.call(this, socketService, cookieService, router, resolver) || this;
        _this.questionText = '';
        _this.questionChoices = [];
        _this.maxTime = SECOND * 20;
        _this.startTime = 0;
        _this.disableButtons = false;
        _this.countDownText = _this.maxTime;
        _this.showTimer = false;
        _this.points = 0;
        return _this;
    }
    TriviaComponent.prototype.messageHandler = function (message) {
        if (message.action === MessageType.Question ||
            (message.action === MessageType.Host &&
                message.content.status === GameStatus.InProgress)) {
            this.disableButtons = false;
            this.waitMode = false;
            this.questionText = message.content.currentQuestion.question;
            this.questionChoices = message.content.currentQuestion.choices;
            this.expiration = message.content.questionExpiration;
            this.startTimer();
        }
    };
    TriviaComponent.prototype.clean = function () {
        this.clearTimer();
    };
    TriviaComponent.prototype.startTimer = function () {
        this.showTimer = true;
    };
    TriviaComponent.prototype.submissionHandler = function (message) {
        this.currentAnswer = message;
        this.points = this.timer.getTimeLeft();
        this.disableButtons = true;
        this.waitMode = true;
        this.clearTimer();
        this.sendAnswer();
    };
    TriviaComponent.prototype.sendAnswer = function () {
        var score = {
            answer: this.currentAnswer,
            points: this.points
        };
        console.log(score);
        this.socketService.send({
            from: this.user,
            content: score,
            action: MessageType.Response,
            gameId: this.gameId
        });
    };
    TriviaComponent.prototype.clearTimer = function () {
        this.showTimer = false;
    };
    TriviaComponent.prototype.timerHandler = function (timerStatus) {
        if (timerStatus.status.ended) {
            this.disableButtons = true;
            this.sendAnswer();
        }
    };
    return TriviaComponent;
}(GameComponent));
export { TriviaComponent };
